<template>
  <van-button
    size="small"
    :disabled="captcha_disabled"
    type="primary"
    @click="sendCaptchaSubmit"
  >{{captcha_text}}</van-button>  
</template>

<script>
import { Notice } from '@/api'
export default {
  name: "captcha",
  props: {
    data: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      captcha_status: 1,
      countDown: 60,
      timer: null,
    }
  },
  computed: {
    captcha_disabled() {
      return this.captcha_status !== 1
    },
    captcha_text() {
      let result = ''
      switch (this.captcha_status) {
        case 1:
          result = '获取验证码'
          break
        case 2:
          result = '正在发送'
          break
        case 3:
          result = `重新发送(${this.countDown}S)`
          break
      }
      return result
    }
  },
  methods: {
    async sendCaptchaSubmit() {
      this.captcha_status = 2
      let valid = this.valid()
      if (valid) {
        try {
          await this.sendCaptcha()
          this.startCountDown()
        } catch (error) {
          this.captcha_status = 1
          this.$tips.toast(error.message)
        }
      } else {
        this.captcha_status = 1
      }
    },
    startCountDown() {
      this.captcha_status = 3
      this.timer = setInterval(() => {
        if (this.countDown === 1) {
          clearTimeout(this.timer)
          this.timer = null
          this.captcha_status = 1
          this.countDown = 60  // 复原
          return
        }
        this.countDown--
      }, 1000)
    },
    async sendCaptcha() {
      if (this.type === 1) {
        await this.$api(Notice.SendCaptcha, { Phone: this.data })
      } else if (this.type === 2) {
        await this.$api(Notice.SendEmailCaptcha, { EMail: this.data })
      }
    },
    valid() {
      let valid = true
      switch (this.type) {
        case 1:
          if (this.data) {
            if (!/^[1][0-9]{10}$/.test(this.data)) {
              this.$tips.toast('无效手机号')
              valid = false
            }
          } else {
            this.$tips.toast('请输入手机号')
            valid = false
          }
          break;
        case 2:
          if (this.data) {
            if (!/^[1][0-9]{10}$/.test(this.data)) {
              this.$tips.toast('无效邮箱')
              valid = false
            }
          } else {
            this.$tips.toast('请输入邮箱')
            valid = false
          }
          break;

        default:
          break;
      }
      return valid
    }
  }
}
</script>

<style>
</style>
